import React from 'react';
import { ChartColumnIcon, RefreshCwIcon, RepeatIcon, RouteIcon, TimerIcon, UsersIcon } from 'lucide-react';
import { SectionCta } from '../SectionCta';
import { pains, questionChain } from '../../data/content';
const iconMap = {
  repeat: RepeatIcon,
  timer: TimerIcon,
  route: RouteIcon,
  chart: ChartColumnIcon,
  refresh: RefreshCwIcon,
  users: UsersIcon
};
export function Pains() {
  return <section className="bg-cream px-4 py-16 sm:py-20" aria-labelledby="pains-title" data-id="element-199" data-mp="316jeqw7s7gli">
      <div className="mx-auto max-w-5xl" data-id="element-200" data-mp="2w8roe6msc2jf">
        <h2 id="pains-title" className="text-center font-serif text-[32px] font-black leading-tight text-ink sm:text-5xl" data-id="element-201" data-mp="2w7ox3xljvy2z">
          Do any of these sound familiar?
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-center text-[17px] text-ink/75" data-id="element-202" data-mp="35z2thwi7ghrw">
          If you answer <strong className="text-ink" data-id="element-203" data-mp="3jyuc6ajo2mc8">YES</strong> to any of these, I built this system for warehouse
          professionals like you.
        </p>

        <ul className="mt-10 grid gap-4 md:grid-cols-2" data-id="element-204" data-mp="3fueaklh3612t">
          {pains.map(p => {
          const Icon = iconMap[p.icon];
          return <li key={p.text} className="flex gap-4 rounded-2xl border-l-4 border-gold bg-white p-5 shadow-sm" data-id="element-205" data-mp="n20lalsfzqhy">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-ink" data-id="element-206" data-mp="ryr25bc2mq4f">
                  <Icon className="h-5 w-5 text-gold" aria-hidden="true" data-id="element-207" data-mp="x0q4chw2rgzs" />
                </span>
                <p className="text-[16px] leading-snug text-ink" data-id="element-208" data-mp="11y9i7gov1rr7">{p.text}</p>
              </li>;
        })}
        </ul>

        <div className="mx-auto mt-14 max-w-2xl text-center" data-id="element-209" data-mp="1aqtjkowjeafq">
          <p className="font-serif text-3xl font-black text-ink sm:text-4xl" data-id="element-210" data-mp="1ard144i9ywt8">And it doesn’t have to stay that way.</p>
          <p className="mt-4 text-[17px] text-ink/80" data-id="element-211" data-mp="1fs0qklquv5lc">
            Because you probably don’t need your team to simply work faster. You need to know:
          </p>
          <ol className="mt-6 space-y-2" data-id="element-212" data-mp="1povpv6uyda0o">
            {questionChain.map((q, i) => <li key={q} className="flex items-center gap-3 rounded-xl bg-ink px-4 py-3 text-left text-[16px] font-semibold text-white" data-id="element-213" data-mp="10102a2hf6av8" data-mpi={i}>
                <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-gold text-sm font-black text-ink" data-id="element-214" data-mp="uyr6kyd5wupf">
                  {i + 1}
                </span>
                {q}
              </li>)}
          </ol>
          <p className="mt-6 text-[17px] font-semibold text-ink" data-id="element-215" data-mp="1ipn6kirruw7r">That’s the principle behind Picking Control 30™.</p>
        </div>

        <SectionCta label="I want a system to control my picking" data-id="element-216" data-mp="1dqtqqjp0it4f" />
      </div>
    </section>;
}